import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Element} from 'react-scroll';
import { Tooltip } from 'react-tippy';
import Aux from '../../../components/Hoc/Aux';
import VimeoEmbed from '../../../components/VimeoEmbed/VimeoEmbed';
import medicare101Thumb from '../../../assets/video/medicare-101-thumb.jpg';
import LearnMore from '../../../components/Forms/LearnMore';
import ReasonsResults from '../../../components/Reasons/ReasonsResults';
import ScrollButton from '../../../components/Header/ScrollButton';
import Accordion from '../../../components/Accordion/Accordion';
import getMedicareFaqs from '../../../helpers/medicareFaqs';
// import medicareRating from '../../../assets/svg/icon-medicare-rating-sm.svg';
import cdphpLogo from '../../../assets/logo.svg';

class MedicareCompareWesternNY extends Component {
  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Medicare Compare Western NY',
      'eventValue': undefined
    });
  }

  render () {
    const accordionData = getMedicareFaqs({ planType: 'ppo' });

    return (
      <Aux>
        <header className='locked landingPage'>
          <div className='main'>
            <div>
              <Link to='/' className='logo'>
                <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
              </Link>
              {/* <p className='eligible'>Enroll anytime before December 7th!</p> */}
            </div>
            <div className='connect'>
              <p>
                <strong>Need help selecting the right Medicare plan?</strong>
                <span><a href='tel:888-519-7898' className='tel phoneswap'>888-519-7898</a> | TTY: 711 <em>M-F, 8 a.m. – 8 p.m.<sup>‡</sup></em></span>
              </p>
            </div>
            <ScrollButton
              text='Contact Me'
              scrollName='learnForm'
              scrollOpts={{
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
                offset: -200
              }} />
          </div>
        </header>

        <article id='medicareCompare'>
          <section className='intro'>
            <div className='wrap'>
              <h1>Compare Our Most Popular<br /> Medicare Advantage Plans</h1>
            </div>
            <div className='wrap sm'>
              <div className='callout'>
                <p className='calloutContent'>Medicare Advantage plans cover more than Original Medicare, protecting you from unexpected&nbsp;costs.</p>
                <VimeoEmbed videoId='1215229413' hash='bd848bae19' title='CDPHP Medicare 101'
                  thumbnail={medicare101Thumb} popover />
              </div>
            </div>
          </section>

          <section>
            <div className='wrap sm'>
              <div className='results medicare container'>
                <div className='table'>
                  <table>
                    <thead>
                      <tr className='heading'>
                        <th className='item'>
                          <p className='note'><strong>Note:</strong> Original Medicare is required for any Medicare Advantage Plan</p>
                        </th>
                        <th>
                          <div className='card medicare'>
                            <h4>Original Medicare <span>Parts A &amp; B</span></h4>
                          </div>
                        </th>
                        <th>
                          <div className='card'>
                            <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
                            <h4>Vital Rx (PPO)*</h4>
                          </div>
                        </th>
                        <th>
                          <div className='card'>
                            <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
                            <h4>Complete Rx (PPO)*</h4>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className='subhead'>
                        <td className='item'>&nbsp;</td>
                        <td><h6><strong>Original Medicare</strong></h6><strong>$185<sup>.00</sup></strong><Tooltip html={(<span className='originalMedicare'>Most people pay the standard Part B monthly premium amount ($185.00 in 2025). Visit <a href='https://www.medicare.gov/basics/costs' target='_blank' rel='noopener noreferrer'>Medicare.gov</a> to learn more.</span>)} arrow='true' interactive='true'><span className='helpTip'>Estimated Monthly Cost</span></Tooltip></td>
                        <td className='hmp'><h6>Vital Rx (PPO)*</h6><strong>$0</strong> <span>Monthly Cost</span></td>
                        <td className='ppo'><h6>Complete Rx (PPO)*</h6><strong>$70<sup>.00</sup></strong> <span>Monthly Cost</span></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Medical Deductible</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>$233</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$0</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Prescription Deductible</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Drug Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$300</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>No Deductible</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Annual Physicals</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$0</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Out of Network Coverage</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>Yes</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>Yes</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Primary Care Visits</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$0</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Specialist Doctor Visits</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$45</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$40</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Dental Allowance</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$725 / year</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$1,400 / year</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Prescription Drugs</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><strong className='helpTip'>$0 - 40%</strong></Tooltip></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><strong className='helpTip'>$0 - 45%</strong></Tooltip></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Hospital Stays</h5></td>
                        <td className='med'><h6>Original Medicare:</h6><Tooltip title='With Original Medicare, you will have a $1,364 deductible for the first 60 days, $341/day from days 61-90, and $682/day for each “lifetime reserve day” after day 90 for each benefit period (up to 60 days over your lifetime) for inpatient hospitalizations. CDPHP Medicare plans protect you from potentially high, unexpected costs by instead offering a flat, predictable copay.' arrow='true'><span className='helpTip'>See Details</span></Tooltip></td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$500 per day,<br /> days 1-5, then $0</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$310 per day,<br /> days 1-6, then $0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Outpatient Surgeries</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$335 - $360</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$275 - $325</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Urgent Care</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$55</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$55</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Worldwide Emergency Care</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$120</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$120</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Maximum Annual<br />Out-of-Pocket Protection</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Protection</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$6,750</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$6,000</strong></td>
                      </tr>
                      {/* <tr>
                        <td className='item'><h5>Centers for Medicare &amp; Medicaid Services Rating<sup>†</sup></h5></td>
                        <td className='med'><h6>Original Medicare:</h6>N/A</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><img src={medicareRating} alt='4.5 out of 5 Medicare Ranking' /></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><img src={medicareRating} alt='4.5 out of 5 Medicare Rankin' /></td>
                      </tr> */}
                    </tbody></table>
                  <p className='medicare-desc'>*Your cost share (copays and coinsurances) may be different for Out-of-Network services.</p>
                </div>
              </div>
            </div>
          </section>

          <section className='compare-expenses'>
            <div className='wrap sm'>
              <div className='container'>
                <div className='navigate expenses medicare-expenses'>
                  <h4>Looking for other Medicare plan options? </h4>
                  <p><a href='/pdf/CDPHP_2025_Medicare_Rochester_Plan_Options_Brochure.pdf' target='_blank' rel='noopener noreferrer'>Explore all our plans</a> or <a href='https://cdphpmedicare1.destinationrx.com/PC/2027/Shopping/Home?AgentID=cdphp-funnel' target='_blank' rel='noopener noreferrer'>enroll online</a> if you’re ready.</p>
                </div>
              </div>
            </div>
          </section>

          <Element name='learnForm'>
            <LearnMore
              area='MedicareQuoteWesternNY'
              MedicareCompare='true'
              phone='888-519-7898 | TTY: 711' />
          </Element>
          <ReasonsResults intro="More Reasons Why You'll Love Us" type='medicareWNY' />

          <section id='faq'>
            <div className='wrap sm'>
              <h2>Frequently Asked Questions</h2>
              {accordionData.map(({ index, title, content }) => (
                <Accordion
                  key={index}
                  id={'faq' + index}
                  title={title}
                  content={content} />
              ))}
            </div>
          </section>
        </article>
      </Aux>
    );
  }
}

export default MedicareCompareWesternNY;